var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"17","viewBox":"0 0 20 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }